/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {makeStyles} from "@material-ui/core/styles/index";

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.down('xs')]: {
            minHeight: theme.spacing(10),
        }
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        ...theme.custom.apiOverviewPage.tabs.sdks.styles
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        maxWidth: '1480px',
    },
    fixedHeight: {
        height: 240,
    },
    title: {
        ...theme.custom.apiOverviewPage.tabs.sdks.title
    },
    notification: {
        paddingLeft: '15px',
        ...theme.custom.apiOverviewPage.tabs.sdks.noSDKLabelStyle
    },
    cardTitle: {
        ...theme.custom.apiOverviewPage.tabs.sdks.SDKLanguageStyle
    },
    cardRoot: {
        ...theme.custom.apiOverviewPage.tabs.sdks.SDKCardStyle
    },
    cardMedia: {
        padding: '30px'
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(8.5),
        [theme.breakpoints.down('sm')]:{
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),        
        },
        [theme.breakpoints.up('lg')]:{
            paddingLeft: 'auto',
            paddingRight: 'auto',        
        }
    },
    loaderContainer: {
        width: "cal(100%-60px)",
        display: "flex",
        justifyContent: "center",
        marginTop: '15%'
    },
    sdkCardWrapper: {
        marginLeft: -theme.spacing(2)
    }
}));
